import { useGetExperiment } from '../hooks'
import {
  EXPERIMENT_NAME_CHRISTMAS_COMMUNICATION_COOLING,
  EXPERIMENT_NAME_CHRISTMAS_COMMUNICATION_OTC,
} from '../model/EXPERIMENT_NAME'

export const useGetIsChristmasCommunicationEnabled = (
  isCoolingProduct: boolean,
): boolean => {
  const christmasCommunicationExperimentOtc = useGetExperiment(
    EXPERIMENT_NAME_CHRISTMAS_COMMUNICATION_OTC,
  )
  const christmasCommunicationExperimentCooling = useGetExperiment(
    EXPERIMENT_NAME_CHRISTMAS_COMMUNICATION_COOLING,
  )

  return (
    (christmasCommunicationExperimentCooling.isEnabled && isCoolingProduct) ||
    (christmasCommunicationExperimentOtc.isEnabled && !isCoolingProduct)
  )
}
